const frTranslation = {
  goToSenecaLearning: "Aller à Seneca Learning 📚",
  continueWithProvider: "Continuer avec {{provider}}",
  redirectBackToTheApp: "Rediriger vers l'application",
};

export default frTranslation;
